/**
 * Route for `appsflyer-integration-mmp-bridge`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AppsflyerIntegrationMmpBridgePage } from "../features/appsflyer-integration-mmp-bridge/AppsflyerIntegrationMmpBridgePage";

export const appsflyerIntegrationMmpBridgeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/appsflyer-integration-mmp-bridge",
	component: AppsflyerIntegrationMmpBridgePage,
});

export default appsflyerIntegrationMmpBridgeRoute;
